import * as React from "react"
import { useEffect } from "react"
import { array, object } from "yup"
import { useValidatorSeeker } from "@ui-seeker/app"

import { CommonFilters } from "@components"
import { disabledCommonFiltersSubmit, retailer } from "@signals"


export default function AdminScrapingDataReviewFilters({ onSubmit }) {
    const { isValid, errors } = useValidatorSeeker({ retailer: retailer.value }, object({
        retailer: array().max(1, "A maximum of one retailer is allowed"),
        ...(!retailer?.value?.length) && {
            retailer: array()
                .min(1, "At least one of retailer be provided")
        }
    }))

    useEffect(() => {
        disabledCommonFiltersSubmit.value = !isValid
    }, [isValid])

    useEffect(() => {
        return () => disabledCommonFiltersSubmit.value = false
    }, [])

    return <CommonFilters
        components={{
            onlySingleDate: true, country: true, site: true
        }}
        compProps={{
            spaceOnlySingleDate: { grid: { md: 10 } },
            country: { grid: { md: 6 } },
            site: { grid: { md: 6 }, error: errors?.retailer }
        }}
        onSubmit={onSubmit}
    />
}